import type { ReactNode } from "react";
import { Platform, ScrollView, StyleSheet, View } from "react-native";

import {
  AppLink,
  BrandMark,
  Container,
  PageTitle,
  Row,
  Screen,
  Stack,
  WebFooter,
} from "~/components/ui";
// TODO: Enable when production store links are approved.
// import { WebStoreBadges } from "~/components/composed/WebStoreBadges";
import {
  radii,
  shadows,
  spacing,
  palette,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";
import { getSiteUrl } from "~/utils/runtime-config";

export function AuthScreen({
  children,
  title,
  subtitle,
}: {
  children: ReactNode;
  title: string;
  subtitle?: string;
}) {
  const stylesheet = useThemedStyles(makeStyles);
  const siteUrl = getSiteUrl();

  return (
    <Screen style={stylesheet.screen}>
      <ScrollView contentContainerStyle={stylesheet.scroll}>
        <View style={stylesheet.body}>
          <Container size="auth">
            <Stack gap="lg">
              <Row justify="center" gap="none" style={stylesheet.brand}>
                <BrandMark size="xl" tone="inverse" />
              </Row>
              <View style={stylesheet.card}>
                <PageTitle title={title} subtitle={subtitle} />
                {children}
              </View>
              {siteUrl && Platform.OS === "web" ? (
                <Stack align="center" gap="none">
                  <AppLink href={siteUrl as never} size="sm" tone="inverse">
                    ← Back to website
                  </AppLink>
                </Stack>
              ) : null}
            </Stack>
          </Container>
        </View>
        {/* TODO: Enable App Store and Google Play badges. <WebStoreBadges /> */}
        <WebFooter tone="inverse" />
      </ScrollView>
    </Screen>
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    screen: { backgroundColor: palette.brandForest },
    scroll: { flexGrow: 1 },
    body: {
      flexGrow: 1,
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
      padding: spacing.l,
    },
    brand: {
      paddingHorizontal: spacing.xl,
    },
    card: {
      width: "100%",
      padding: spacing.xl,
      borderRadius: radii.l,
      backgroundColor: colors.background,
      gap: spacing.l,
      ...shadows.md,
    },
  });
